import React from 'react'
import ReactQuill from 'react-quill'
import Box from '@material-ui/core/Box'
import 'react-quill/dist/quill.bubble.css'

import { getTimestamp } from '@utils/dateParser'
import { IconButton } from '@components/Button'
import { Tooltip } from '@components/Tooltip'
import { NotesContext } from '../../context'
import { EditIcon } from '@components/Icons/EditIcon'
import { DeleteIcon } from '@components/Icons/DeleteIcon'
import { VisibilityIcon } from '@components/Icons/VisibilityIcon'
import { InvisibilityIcon } from '@components/Icons/InvisibilityIcon'

export const Note = ({ note, index, editable }) => {
  return (
    <div className='scenario-notes__note'>
      <NoteHeader note={note} index={index} showEditActions={editable} />
      <div className='note-quill'>
        <ReactQuill readOnly theme='bubble' value={note.body} />
      </div>
    </div>
  )
}

const NoteHeader = ({ note, index, showEditActions }) =>{
  const { authorName, updated_at: timestamp, visibility, isAuthor } = note
  const { actions, state: { loading } } = React.useContext(NotesContext)
  const { goToUpdateNote, toggleNoteVisibility, goToDeleteNote } = actions

  const isPrivate = visibility == 1

  const handleToggle = (index) => {
    toggleNoteVisibility(index)
  }

  React.useEffect(() => {
    if (!toggleNoteVisibility && setIsPrivate) {
      setIsPrivate(false)
    }
  }, [toggleNoteVisibility])

  const lastUpdated = getTimestamp(timestamp)

  return (
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems="center"
      className='note-header'
    >
      <div>
        <p className='author'><b>{authorName || 'New scenario note'}</b></p>
        <p className='timestamp'>{ lastUpdated ? `Last updated: ${lastUpdated}` : ''}</p>
      </div>
      { showEditActions &&
        <div className='actions'>
          { isAuthor && <IconButton className='button button--icon' Icon={EditIcon} onClick={() => goToUpdateNote(index)} disabled={loading} /> }
          <Tooltip title={isPrivate ? 'Make note public' : 'Make note private'}> 
            <IconButton className='button button--icon' Icon={isPrivate ? VisibilityIcon : InvisibilityIcon} onClick={() => handleToggle(index)} disabled={loading} />
          </Tooltip>
          { isAuthor &&
            <IconButton className='button button--icon button--delete' Icon={DeleteIcon} onClick={() => goToDeleteNote(index)} disabled={loading} />
          }
        </div>
      }
    </Box>
  )
}

